import React, { useState } from "react";
import { json, Link } from "react-router-dom";
import { useAuth } from "../AuthContext";

const Footer = () => {
    return (
        <>
            <div className="hidden md:flex md:flex-row justify-center w-full fixed bottom-0 bg-teal-900 text-white p-1 z-40">TestView all rights reserved @ 2024.</div>
        </>
    )
}

export default Footer